// Metric (API) to imperial (UI). Every conversion lives here.
export const M_TO_FT = 3.28084;
export const MPS_TO_MPH = 2.236936;
export const MPS_TO_FPM = 196.8504;

const NBSP = " ";
const nf0 = new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const nf2 = new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function fmt1(n: number): string {
  return nf1.format(n);
}

export function fmtInt(n: number): string {
  return nf0.format(n);
}

export function ft(m: number | null | undefined): string {
  return m == null ? "--" : `${nf0.format(m * M_TO_FT)}${NBSP}ft`;
}

export function mph(mps: number | null | undefined): string {
  return mps == null ? "--" : `${nf0.format(mps * MPS_TO_MPH)}${NBSP}mph`;
}

export function fpm(mps: number | null | undefined): string {
  if (mps == null) return "--";
  const v = Math.round(mps * MPS_TO_FPM);
  const sign = v > 0 ? "+" : "";
  return `${sign}${nf0.format(v)}${NBSP}ft/min`;
}

export function degF(f: number | null | undefined): string {
  return f == null ? "--" : `${nf0.format(f)}${NBSP}°F`;
}

export function pct(p: number | null | undefined): string {
  return p == null ? "--" : `${nf0.format(p)}%`;
}

export function volts(v: number | null | undefined): string {
  return v == null ? "--" : `${nf1.format(v)}${NBSP}V`;
}

export function mvToVolts(mv: number | null | undefined): string {
  return mv == null ? "--" : `${nf2.format(mv / 1000)}${NBSP}V`;
}

export function ms(n: number | null | undefined): string {
  return n == null ? "--" : `${nf0.format(n)}${NBSP}ms`;
}

export function heading(deg: number | null | undefined): string {
  if (deg == null) return "---";
  const d = ((Math.round(deg) % 360) + 360) % 360;
  return `${String(d).padStart(3, "0")}°`;
}

export function coord(v: number | null | undefined): string {
  return v == null ? "--" : v.toFixed(5);
}

export type SignalQuality = "strong" | "good" | "weak" | "poor";

/** Button radio RSSI in dBm. */
export function rssiQuality(dbm: number): SignalQuality {
  if (dbm >= -60) return "strong";
  if (dbm >= -70) return "good";
  if (dbm >= -80) return "weak";
  return "poor";
}

export function gpsFixLabel(fix: number | null | undefined): string {
  if (fix == null || fix <= 1) return "NO FIX";
  if (fix === 2) return "2D FIX";
  if (fix === 3) return "3D FIX";
  return fix === 4 ? "DGPS" : "RTK";
}
